import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function uniqueValues<T>(valArr: Array<T>) {
  return valArr.filter(removeDuplicated);
}

export function removeDuplicated<T>(value: T, index: number, array: T[]) {
  return array.indexOf(value) === index;
}